export { default as AboutWasticPageSchema } from './about-wastic';
export { default as ContactUsPageSchema } from './contact-us';
export { default as FaqPageSchema } from './faq';
export { default as GalleryPageSchema } from './gallery';
export { default as HomePageSchema } from './home';
export { default as NavigationMenuSchema } from './menu';
export { default as PrivacyPolicyPageSchema } from './privacy-policy';
export { default as ShippingPolicyPageSchema } from './terms-of-service';
export { default as TermsOfServicePageSchema } from './shipping-policy';
export { default as SustainableMovePageSchema } from './sustainable-move';